// @ts-ignore
import { AppHeader } from '@coreui/react';
import * as React from 'react';
import { useGlobalContext } from '../../global';
import { ODLoading } from '../../loading';
import { ODHeader } from './header/ODHeader';
export var ODCommonMainLayoutWithoutSideBar = function (props) {
    var renderHeader = props.renderHeader, children = props.children;
    var _a = useGlobalContext().state.def.appHeader, topBorderColor = _a.topBorderColor, topBorderSize = _a.topBorderSize;
    return (React.createElement("div", { className: "app", style: { borderTop: topBorderSize + " solid " + topBorderColor } },
        React.createElement(AppHeader, { fixed: true },
            React.createElement(React.Suspense, { fallback: ODLoading }, renderHeader ? renderHeader() : React.createElement(ODHeader, null))),
        React.createElement("div", { className: "app-body" },
            React.createElement("main", { style: { display: 'flex', flexDirection: 'column', marginLeft: 0 } }, children))));
};
//# sourceMappingURL=ODCommonMainLayoutWithoutSideBar.js.map